import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (data) => Object.keys(data);
const namesSelector = defineSelectorResultFunction({
    id: 'names',
    resultFunction,
    dependencies: [
        { selector: 'data' },
    ],
});
export default namesSelector;
